






















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Card, Button, ButtonGroup } from '@alpha/ink'
import CreateYourOwn from '@/assets/img/create-your-own.svg?inline'
import ChooseTemplate from '@/assets/img/choose-template.svg?inline'
import TemplateTestContentModal from '@/components/TestDetails/DefaultTestCreation/TemplateTestContentModal.vue'
import ClassicTestContentModal from '@/components/TestDetails/DefaultTestCreation/ClassicTestContentModal.vue'
import * as db from '@shared/types/database'
import { TestStatus } from '@shared/types/database'
import TemplateManager, { Location } from '@/components/Templates/TemplateManager.vue'
import store from '@/store'
import ClassicTestContent from '@/components/TestDetails/ClassicTestContent.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import TaggedCard from './TaggedCard.vue'
import ConfirmExitPopup from '@/components/TestDetails/DefaultTestCreation/ConfirmExitPopup.vue'
import { TemplateSubmissionPayload } from '@/utilities/template-helpers'
import api from '@/api'
import TestTypeSelectionCard from '@/components/TestDetails/DefaultTestCreation/TestTypeSelectionCard.vue'
import A from '@/utilities/alpha'
import { SelectedTemplate } from '@/types/frontend'

@Component({
  components: {
    TestTypeSelectionCard,
    ClassicTestContentModal,
    TemplateTestContentModal,
    ClassicTestContent,
    LoadingIndicator,
    TemplateManager,
    DropdownButton,
    ConfirmExitPopup,
    ChooseTemplate,
    CreateYourOwn,
    ButtonGroup,
    Button,
    Card,
    TaggedCard
  }
})
export default class TestTypeSelection extends Vue {
  @Prop({ required: true }) test!: db.Test
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) projectId!: string
  @Prop({ required: false }) tag?: string | null
  @Prop({ required: false }) initialTemplate!: SelectedTemplate

  selectedTemplate: SelectedTemplate = null

  showDeleteContentDialog = false
  showChooseTemplateModal = false
  showClassicTestModal = false
  location = Location.DefaultDraftTestCreation
  loading = false

  mounted () {
    if (this.test.payload.testType === 'Template' && !this.initialTemplate) {
      // Wait for the test content to come in
      this.loading = true
    } else if (this.initialTemplate) {
      this.selectedTemplate = A.clone(this.initialTemplate)
    }
  }

  get isContentLoading () {
    return this.loading || (this.test.payload.testType === 'Template' && !this.selectedTemplate)
  }

  get showEditContentButton () {
    return this.test.payload.status === TestStatus.Draft
  }

  @Watch('initialTemplate')
  async updateInitialTemplate (newValues: SelectedTemplate) {
    this.selectedTemplate = { ...newValues! }
    this.loading = false
  }

  toggleEditContent () {
    if (this.test.payload.testType === 'Template') {
      this.saveTemplate(null)
    } else {
      this.toggleClassicTestModal()
    }
  }

  async deleteTestContent () {
    this.showDeleteContentDialog = false
    this.loading = true

    await store.dispatch.testCreation.resetTestType({
      testId: this.testId,
      workspaceId: this.workspaceId
    })

    this.loading = false
  }

  get templateFieldValues () {
    return this.test.payload.testTemplateId === -1 ? null : this.test.payload.templateFieldValues
  }

  async saveTemplate (templateSubmission: TemplateSubmissionPayload | null) {
    if (templateSubmission && this.showChooseTemplateModal) {
      const template = await api.getTemplateById(templateSubmission?.testTemplateId!.toString(), store.state.workspace.accountId!)
      this.selectedTemplate = { template, templateValues: templateSubmission?.templateFieldValues || null }
    }
    this.toggleChooseTemplateModal()
  }

  toggleChooseTemplateModal () {
    this.showChooseTemplateModal = !this.showChooseTemplateModal
  }

  toggleClassicTestModal () {
    this.showClassicTestModal = !this.showClassicTestModal
  }
}
